module.exports = {
  title: '毛胚資料',
  schema: {
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        unique: true,
        name: '毛胚代碼',
      },
      name: {
        type: 'String',
        name: '毛胚名稱',
      },
      material: {
        type: 'String',
        name: '毛胚材料',
      },
      color: {
        type: 'String',
        name: '毛胚顏色',
      },
    },
  },
  index: {
    primary: {
      key: {
        name: 1,
      },
      unique: true,
    },
  },
  list: {
    ui: {
      fields: [
        { path: 'key', width: 90 },
        { path: 'name', width: 250 },
        { path: 'material', width: 90 },
        { path: 'color', width: 100 },
      ],
    },
  },
  edit: {
    ui: [
      {
        name: 'formEditor',
        cols: { default: 500 },
        rows: [
          [{ path: 'key' }],
          [{ path: 'name' }],
          [{ path: 'material' }],
          [{ path: 'color' }],
        ],
      },
    ],
  },
}
